import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';


class OrgService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.ORG = '/api/org';
        this.GET_BY_ID = '/{id}';
        this.SEARCH_LIST_BY_KEYWORD = '/search/keyword';
        this.GET_LIST_FOR_USER_ID = '/list/user/{userId}';
        this.ADD_USER_TO_ORG = '/user';

        this.REMOVE_CONTRIBUTOR = '/remove/contributor';
        this.UPDATE_CONTRIBUTOR = '/update/contributor';
        this.SETUP_USER_TUTORIAL = '/setup/tutorial/user/{userId}';
        this.SETUP_LEADS_USER = '/setup/leads/user';
    }

    /**
     * This class manages the REST Protocols for Organizations.
     *
     * GET Requests:
     *     1) getOrgById - GET By ID
     *     2) searchOrgListByKeyword - GET SEARCH LIST By KEYWORD
     *     3) getOrgListForUser - GET ORG LIST for USER ID
     *     4) getOrgListWithTeamListForUser - GET ORG LIST With TEAM LIST for USER
     *
     * POST Requests:
     *     1) createOrg - CREATE Organization
     *
     * PUT Requests:
     *     1) updateOrg - UPDATE Organization
     *
     */

    async getOrgById(id) {
        try {
            let url = window.location.origin + this.ORG + this.GET_BY_ID;
            url = url
                .replace('{id}', id)
            const orgData = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return orgData;
        } catch(err) {
            console.log(err);
        }
    }

    async searchOrgListByKeyword(keyword) {
        try {
            let csrfToken = Cookies.get('XSRF-TOKEN');
            let url = window.location.origin + this.ORG + this.SEARCH_LIST_BY_KEYWORD;
            let keywordMap = {
                'keyword': keyword
            }
            const orgList = this.fetch(url, {
                   method:'POST',
                   headers: {
                       'Content-Type': 'application/json',
                       'X-XSRF-TOKEN': csrfToken
                   },
                   body: JSON.stringify(keywordMap)
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return orgList;
        } catch(err) {
            console.log(err);
        }
    }

    async getOrgListForUser(userId) {
        let url = window.location.origin + this.ORG + this.GET_LIST_FOR_USER_ID;
        url = url
            .replace('{userId}', userId)
        try {
            const orgDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return orgDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async updateContributorPermissionInOrg(updateMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.ORG + this.UPDATE_CONTRIBUTOR;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(updateMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async createOrg(org){
        let url = window.location.origin + this.ORG;
        try{
            let csrfToken = Cookies.get('XSRF-TOKEN');
            const orgCreated = this.fetch(url, {
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(org)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return orgCreated;
        }
        catch(err){
            console.log(err);
        }
    }

    async updateOrg(org){
        try{
            let url = window.location.origin + this.ORG;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            const orgCreated = this.fetch(url, {
                method:'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(org)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return orgCreated;
        }
        catch(err){
            console.log(err);
        }
    }

    async deleteOrg(orgId){
        try{
            let deleteOrgObj = {
                'id': orgId
            }
            let url = window.location.origin + this.ORG;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            const orgCreated = this.fetch(url, {
                method:'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(deleteOrgObj)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return orgCreated;
        }
        catch(err){
            console.log(err);
        }
    }

    async removeContributorPermissionFromOrganization(removeMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.ORG + this.REMOVE_CONTRIBUTOR;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(removeMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async setupUserTutorial(userId) {
        try {
            let csrfToken = Cookies.get('XSRF-TOKEN');
            let url = window.location.origin + this.ORG + this.SETUP_USER_TUTORIAL;
            url = url.replace('{userId}', userId);
            
            const tutorialSetup = await this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify({}) // Empty body since endpoint doesn't require specific data
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                });
            
            return tutorialSetup;
        } catch(err) {
            console.log('Error setting up tutorial:', err);
            throw err;
        }
    }

    async setupLeadsUser(body) {
        try {
            let csrfToken = Cookies.get('XSRF-TOKEN');
            let url = window.location.origin + this.ORG + this.SETUP_LEADS_USER;

            const tutorialSetup = await this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                });

            return tutorialSetup;
        } catch(err) {
            console.log('Error setting up tutorial:', err);
            throw err;
        }
    }
}

export default OrgService;
